export enum IntervalType {
    None = "None",
    Counter = "Counter",
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly1 = "Monthly1",
    Monthly2 = "Monthly2",
    Yearly1 = "Yearly1",
    Yearly2 = "Yearly2",
    Minutely ="Minutely",
}